import { RouteComponentProps } from '@reach/router';
import React, { useContext } from 'react';
import { Query } from 'react-apollo';
import Timeline, { Note } from '../../../../components/Timeline';
import { ErrorScreen } from '../../../../components/utils';
import { NotebookContext } from '../../../../context/NotebookContext';
import { NotesQuery, NotesQueryVariables } from '../../../../queries/__generated__/NotesQuery';
import { notesQuery } from '../../../../queries/notes';
import EmptyState from './EmptyState';

interface SubjectFeedProps extends RouteComponentProps {
  subject: {
    id: string;
  };
  setActiveTab: (value: 'SETTINGS') => void;
}

const SubjectFeed: React.FC<SubjectFeedProps> = ({ subject, setActiveTab }) => {
  const { notebook } = useContext(NotebookContext);

  return (
    <Query<NotesQuery, NotesQueryVariables>
      query={notesQuery}
      variables={{
        input: {
          notebookId: notebook.id,
          subjectIds: [subject.id],
          first: 20
        }
      }}
    >
      {({ data, error, loading }) => {
        if (loading) {
          return <div />;
        }
        if (error) {
          return <ErrorScreen error={error.message} />;
        }

        let notes: Note[] = [];

        if (data!.notes.edges) {
          notes = data!.notes.edges.map(e => e!.node!);
        }

        return (
          <>
            {notes.length > 0 && <Timeline notes={notes} />}

            {notes.length < 1 && <EmptyState setActiveTab={setActiveTab} />}
          </>
        );
      }}
    </Query>
  );
};

export default SubjectFeed;
